import { SOURCE_TYPE_VALUES } from "constant/panel";
import { PlaySource } from "type/panel/Panel.type";

export const sourceFieldsInitial = (): PlaySource => {
  return {
    type: SOURCE_TYPE_VALUES.TEXT,
    fileName: "",
    content: "",
    start: 0,
    duration: 0,
    wait: 0,
    repeat: 1,
  };
};

export const sourceFieldsStateDefault = (
  defaultSourceFields: PlaySource | null
): PlaySource => {
  return defaultSourceFields === null
    ? sourceFieldsInitial()
    : { ...defaultSourceFields };
};

export const sourceFieldsFileNameDefault = (
  defaultSourceFields: PlaySource | null
): string => {
  let fileName: string = "";
  if (defaultSourceFields !== null && defaultSourceFields.fileName) {
    fileName = defaultSourceFields.fileName;
  }
  return fileName;
};

export const fieldRefNumberGet = (ref: any): number => {
  let result: number = 0;
  const refValue: any = ref.current ? parseInt(ref.current.value) : 0;
  if (!isNaN(refValue)) {
    result = refValue;
  } else {
    result = 0;
  }
  return result;
};
